"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFirebaseToken = exports.setFirebaseToken = exports.getFirebaseToken = exports.removeAuthToken = exports.setAuthToken = exports.getAuthToken = void 0;
var localforage_1 = __importDefault(require("localforage"));
var config_1 = __importDefault(require("../config"));
// Side effects Services
function getAuthToken() {
    return localforage_1.default.getItem(config_1.default.tokenKey);
}
exports.getAuthToken = getAuthToken;
function setAuthToken(token) {
    return localforage_1.default.setItem(config_1.default.tokenKey, token);
}
exports.setAuthToken = setAuthToken;
function removeAuthToken() {
    return localforage_1.default.removeItem(config_1.default.tokenKey);
}
exports.removeAuthToken = removeAuthToken;
function getFirebaseToken() {
    return localforage_1.default.getItem("FIREBASE_".concat(config_1.default.tokenKey));
}
exports.getFirebaseToken = getFirebaseToken;
function setFirebaseToken(token) {
    return localforage_1.default.setItem("FIREBASE_".concat(config_1.default.tokenKey), token);
}
exports.setFirebaseToken = setFirebaseToken;
function removeFirebaseToken() {
    return localforage_1.default.removeItem("FIREBASE_".concat(config_1.default.tokenKey));
}
exports.removeFirebaseToken = removeFirebaseToken;
